import { Component } from '@angular/core';
import { ConfigurationsBlockComponent } from '../configurations-block/configurations-block.component';

@Component({
  templateUrl: 'game-server-configurations.component.html',
  standalone: true,
  imports: [ConfigurationsBlockComponent]
})
export class GameServerConfigurationsComponent {}
